/**
 * /agente-raciocinio — LP de venda do Agente de Raciocínio Clínico (Fukusawa)
 * Com a ação Semana da Fisioterapia ativa, exibe barra superior + contador da
 * ação; fora da ação, a LP mantém a oferta e o checkout, sem o tema da ação.
 */
import { createFileRoute } from "@tanstack/react-router";
import mockup from "@/assets/agente/mockup-optimized.webp.asset.json";

import { AgenteRaciocinioPage } from "@/components/lps/AgenteRaciocinioPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

export const Route = createFileRoute("/agente-raciocinio")({
  validateSearch: (search: Record<string, unknown>): { preview?: boolean } =>
    search.preview === "1" || search.preview === 1 || search.preview === true
      ? { preview: true }
      : {},
  head: () => ({
    meta: [
      { title: "Agente de Raciocínio Clínico · Fukusawa | FEO" },
      {
        name: "description",
        content:
          "Nunca mais atenda um paciente sozinho(a). O Fukusawa é a IA da FEO treinada com mais de 1.000 horas de conteúdo técnico para apoiar seu raciocínio clínico.",
      },
      { property: "og:title", content: "Agente de Raciocínio Clínico · Fukusawa | FEO" },
      {
        property: "og:description",
        content:
          "A IA da FEO criada para apoiar seu raciocínio clínico e suas decisões baseadas em evidências.",
      },
      { property: "og:url", content: "https://fisioemortopedia.com.br/agente-raciocinio" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: `https://fisioemortopedia.com.br${mockup.url}` },
      { name: "twitter:image", content: `https://fisioemortopedia.com.br${mockup.url}` },
      { name: "twitter:title", content: "Agente de Raciocínio Clínico · Fukusawa | FEO" },
      {
        name: "twitter:description",
        content: "A IA da FEO para apoiar seu raciocínio clínico.",
      },
      { name: "robots", content: "index,follow" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/agente-raciocinio" }, { rel: "preload", as: "image", href: mockup.url, fetchPriority: "high" }],
  }),
  loader: () => getAcoesStateFn(),
  component: AgenteRaciocinioRoute,
});

function AgenteRaciocinioRoute() {
  const acoes = Route.useLoaderData();
  const { preview } = Route.useSearch();
  const ativa = Boolean(acoes?.semanadafisio?.ativa) || preview === true;
  return <AgenteRaciocinioPage ativa={ativa} />;
}
